import { ProductOrganizationDialogConfig, FieldType, ProductOrganizationTableTemplate } from '../../product.model';

export const guidesDialogConfig: ProductOrganizationDialogConfig = {
	title: 'Przewodnicy',
	configType: 'guides',
	fields: [
		{ key: 'firstName', label: 'Imię', type: FieldType.TEXT, required: true },
		{ key: 'lastName', label: 'Nazwisko', type: FieldType.TEXT, required: true },
		{ key: 'email', label: 'Email', type: FieldType.EMAIL, placeholder: 'example@gmail.com' },
		{ key: 'phone', label: 'Tel.', type: FieldType.PHONE, placeholder: '+48123123123' },
		{
			key: 'destination',
			label: 'Lokalizacja',
			type: FieldType.SELECT,
			required: true,
			options: [],
			apiOptions: { apiKey: 'location/basic', valueApiKey: 'id', labelApiKey: 'name', searchApiKey: 'search' },
		},
		{ key: 'note', label: 'Notatka', type: FieldType.TEXTAREA },
	],
};

export const guidesTableTemplate: ProductOrganizationTableTemplate[] = [
	...guidesDialogConfig.fields.map((field) => ({
		key: field.key,
		label: field.label,
	})),
	{ key: 'createdBy', label: 'Utworzone przez' },
	{ key: 'createdAt', label: 'Utworzone' },
	{ key: 'edit', label: '' },
];
